import { saveDataTransformations } from 'redux/modules/project'
import { close as closeForm } from './dataTransformationsForm/close'

export const save = (dataTransformations, dataTransformation) => dispatch => {
  if (!dataTransformation.mock) {
    dispatch(saveDataTransformations(dataTransformations, dataTransformation))
  }
  dispatch(closeForm())
}
